import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, OnInit, Input } from '@angular/core';
import { Price, RetailPrice } from 'src/erp-articles/erp-common/erp-common.model';
import { TranslationService } from '@sdbn/common';
import { ConfigurationService } from '@sdbn/appclient';

@Component({
  selector: 'app-retailprice-list',
  templateUrl: './retailprice-list.component.html',
  styleUrls: ['./retailprice-list.component.scss']
})
export class RetailpriceListComponent implements OnInit {

  priceScale = 2;

  @Input() columns: string[];

  @Input() datasource: MatTableDataSource<RetailPrice>;

  @Input() editRetailPriceFunction: (index: any) => any;

  @Input() removeRetailPriceFunction: (index: any) => any;

  constructor(private liveAnnouncer: LiveAnnouncer,
              public cps: ConfigurationService,
              public translationService: TranslationService) {

    this.priceScale = this.cps.getClientParamValue('erp.use-three-digit-prices', 'false') === 'true' ? 3 : 2;

  }

  ngOnInit(): void {
  }

    /** Announce the change in sort state for assistive technology. */
    announceSortChange(sortState: Sort) {
      this.sortTableData(sortState);
    }

    editRetailPrice(price: Price, index: number) {
      this.editRetailPriceFunction(index);
    }

    removeRetailPrice(price: Price, index: number) {
      this.removeRetailPriceFunction(index);
    }

  private sortTableData(sort: Sort) {
    const sortColumn = sort.active;
    const sortOrder = sort.direction === 'desc' ? -1 : 1;
    if (sortColumn === 'valid-from') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1ValidFrom = r1.validPeriod?.from != null ? r1.validPeriod?.from?.getTime() : 0;
          const r2ValidFrom = r2.validPeriod?.from != null ? r2.validPeriod?.from?.getTime() : 0;
          console.log('sortresult', r1ValidFrom, r2ValidFrom, (r1ValidFrom - r2ValidFrom) * sortOrder);
          return (r1ValidFrom - r2ValidFrom) * sortOrder;
        });
    } else if (sortColumn === 'valid-until') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1ValidUntil = r1.validPeriod?.until != null ? r1.validPeriod?.until?.getTime() : 0;
          const r2ValidUntil = r2.validPeriod?.until != null ? r2.validPeriod?.until?.getTime() : 0;
          return (r1ValidUntil - r2ValidUntil) * sortOrder;
        });
    } else if (sortColumn === 'price-net') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1PriceNet = r1.priceNet != null ? r1.priceNet : 0;
          const r2PriceNet = r2.priceNet != null ? r2.priceNet : 0;
          return (r1PriceNet - r2PriceNet) * sortOrder;
        });
    } else if (sortColumn === 'tax-rate') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1TaxRate = r1.taxRate != null ? r1.taxRate : 0;
          const r2TaxRate = r2.taxRate != null ? r2.taxRate : 0;
          return (r1TaxRate - r2TaxRate) * sortOrder;
        });
    } else if (sortColumn === 'price-vat') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1PriceVat = r1.priceVat != null ? r1.priceVat : 0;
          const r2PriceVat = r2.priceVat != null ? r2.priceVat : 0;
          return (r1PriceVat - r2PriceVat) * sortOrder;
        });
    } else if (sortColumn === 'reference-date') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1ReferenceDate = r1.referenceDate != null ? r1.referenceDate : '';
          const r2ReferenceDate = r2.referenceDate != null ? r2.referenceDate : '';
          return r1ReferenceDate.localeCompare(r2ReferenceDate) * sortOrder;
        });
    }

  }
}
